import { ShowCashAccountType } from '@shared/api/member/member.interface';

//* 실제 입력으로 사용하는 것
export enum MemberFormInputsEnum {
  Name = 'name',
  RelationType = 'relationType',
  PhoneNumber = 'phoneNumber',
  CashAccountId = 'cashAccountId',
  CashAccount = 'cashAccount',
  AccountHolder = 'accountHolder',
  Bank = 'bank',
  AccountHolderSame = 'accountHolderSame',
  ShowCashAccountType = 'showCashAccountType',
}

export interface MemberIFormInput {
  _id: string; // member._id
  [MemberFormInputsEnum.Name]: string; // member.fullname
  [MemberFormInputsEnum.RelationType]: string; // member.relationType
  [MemberFormInputsEnum.PhoneNumber]: string; // member.phoneNumber
  [MemberFormInputsEnum.CashAccountId]?: string; // member.cashAccount._id
  [MemberFormInputsEnum.CashAccount]: string; // member.cashAccount.account
  [MemberFormInputsEnum.AccountHolder]: string; // 예금주
  [MemberFormInputsEnum.Bank]: string; // member.cashAccount.bank
  [MemberFormInputsEnum.AccountHolderSame]: boolean; // 예금주 동일
  [MemberFormInputsEnum.ShowCashAccountType]: ShowCashAccountType; // 계좌 모두 표시
  isVerified: boolean; // member.cashAccount.isVerified
  cashAccountModalConfirmed: boolean;
  isNew: boolean;
}

export interface MemberIFormInputs {
  member: MemberIFormInput[];
}

export const vacantMemberInputForm = [
  {
    _id: '',
    [MemberFormInputsEnum.Name]: '',
    [MemberFormInputsEnum.RelationType]: '',
    [MemberFormInputsEnum.PhoneNumber]: '',
    [MemberFormInputsEnum.CashAccount]: '',
    [MemberFormInputsEnum.AccountHolder]: '',
    [MemberFormInputsEnum.Bank]: '',
    [MemberFormInputsEnum.AccountHolderSame]: true,
    [MemberFormInputsEnum.ShowCashAccountType]: ShowCashAccountType.Self,
    isVerified: false,
    cashAccountModalConfirmed: false,
    isNew: false,
  },
];
